module.exports = __webpack_public_path__ + "img/cover-5-lg.fb7293bc.jpg";